import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    height: 200,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 100
  }
})

export {
  useStyles
}
